import axios from 'axios'

export default axios.create({
  baseURL: 'https://xrwssmpegziqis6qmnz27lymvi0rpujl.lambda-url.ap-south-1.on.aws',
})

// https://blue-cobra-kit.cyclic.app  ----snehajeevana

// https://ruby-panda-shoe.cyclic.app  ---- client-test
